import React, {Component} from 'react';
import AddressForm from "./inputForms/streetAddressForm"
import PersonalInfo from "./inputForms/personalInfoForm"
import TournamentProfile from "./inputForms/tournamentProfileForm"
import Bio from "./inputForms/bioForm"
import {  avatarUrl, saveAvatar, newReviseUser, setDataPreference,  setDataMembership, sendMailById, formatDate } from "../../api";
import ModalWindow from '../../common/modalWindow'
import TagList from "../../common/tagList"
import AvatarEditor from "../../common/avatarEditor"
import AvatarDisplay from "../../common/avatarDisplay"
import Modal from 'react-responsive-modal';
const TEST_NOTIFICATION_TEMPLATE = process.env.REACT_APP_TEST_NOTIFICATION_TEMPLATE;


class DBAccountInfo extends Component {
    constructor(props) {
        super(props);
        this.sendTestNotification = this.sendTestNotification.bind(this);
        this.turnOffAutoRenew = this.turnOffAutoRenew.bind(this);
        this.onCloseAvatarModal = this.onCloseAvatarModal.bind(this);
        this.onAvatarCrop = this.onAvatarCrop.bind(this);
        
        this.state = {
            data: { ...this.props.item, avatar: avatarUrl(this.props.item._id)},
            sendingText: "",
            open: false,
            openAvatar: false,
            editedAvatar: null,
            sequence: 0
        };

    }

    onCloseBillModal = (mode, values) => {
        if (mode === 'address') {

            newReviseUser({billStreet: values.street, billCity: values.city, billPostalCode: values.postalCode, 
                        billState: values.state, billCountry: values.country}, this.state.data._id)
                .then(d2 => { 
                    this.setState({ open: false, data: d2.user }); 
                })
        } 
    };

    onCloseShipModal = (mode, values) => {
        if (mode === 'address') {
            newReviseUser({
                shipStreet: values.street,
                shipCity: values.city,
                shipState: values.state,
                shipPostalCode: values.postalCode,
                shipCountry: values.country
            }, this.state.data._id).then(d2 => {
                this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
            })
        }
    };

    onCloseTournamentProfileModal = (mode, values) => {
        if (mode === 'tournamentProfile') {
            newReviseUser({            
                club: values.club,
                experience: values.experience,
                ageGroup: values.age,
                gender: values.gender,
                phone: values.phone}, this.state.data._id).then(d2 => {
                    this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
                })
        } 
    };
    
    onClosePersonalInfoModal = (mode, values) => {
        if (mode === 'pii') {
            newReviseUser({            
                displayname: values.displayname,
                firstname: values.firstname,
                lastname: values.lastname,
                phone: values.phone,
                email: values.email}, this.state.data._id).then(d2 => {
                    this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
                })            
        } else if (mode === 'pwd') {
            newReviseUser({            
                password: values.password}, this.state.data._id).then(d2 => {
                    this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
                }) 
        } 
    };
    
    onCloseNotificationModal = (mode, values) => {
        if (mode === 'notifications') {
            newReviseUser({preferences: values}, this.state.data._id).then(d2 => {
                    this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
                })     
        }
    };

    onCloseMembershipModal = (mode, values) => {
        if (mode === 'membership') {
            newReviseUser({preferences: values}, this.state.data._id).then(d2 => {
                this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
            })  
        }
    };
        
    onPreferenceDataChange = (evt) => {
        const id = evt.target.id
        const checked = evt.target.checked

        let state = this.state;
        state.data.preferences[id] = checked;

        setDataPreference(state.data._id, id, checked );
        this.setState(state);
    };
           
    onMembershipDataChange = (evt) => {
        const id = evt.target.id
        const checked = evt.target.checked

        if (id === 'autoRenew' && checked === false) {
            this.setState({openId: "1", open: true});
        }
    };

    turnOffAutoRenew() {
        let state = this.state;
        state.data.primeMembership.autoRenew = false;
        setDataMembership(state.data._id, 'autoRenew', false );
        state.open = false;

        this.setState(state);
    }

    onAvatarCrop = (editedAvatar) => {
        this.setState({editedAvatar});

    }

    onOpenAvatarModal = () => {
        this.setState({  openAvatar: true });
    };

    onCloseAvatarModal = (mode) => {
        if(mode === true && this.state.editedAvatar)
        {        
            let data = this.state.data;
            data.avatar = this.state.editedAvatar;

            saveAvatar(data._id, this.state.editedAvatar).then(d2 => {
                this.setState({ openAvatar: false, data: data, sequence: this.state.sequence+1 });
            }) 
        } else {
            this.setState({ openAvatar: false });
        }
    };

    onCancel = () => {
        this.setState({open: false});
    };
    
    onCloseBio = (mode, values) => {
        if (mode === 'bio') {
            newReviseUser({bio: values.bio}, this.state.data._id).then(d2 => {
                this.setState({ open: false, data: d2.user ? d2.user : this.state.data }); 
            })  
        } 
    };

    sendTestNotification = () => {
        this.setState({sendingText: "..."})
        // test: 5e2864a830cc3f63a04b20b0
        // order: 5e2865b130cc3f63a04b20bb
        // twelcome: 5e92315242ca017795275f71
        // warning: 5e923fbcf3b0cc7b2747bf21
        sendMailById(TEST_NOTIFICATION_TEMPLATE, [this.state.data._id])
        this.setState({sendingText: ""})
    };

    componentDidUpdate(prevProps) {
        if(prevProps.item !== this.props.item) {
            this.setState({data: this.props.item});
        }
    }

    render(){
            const { data } = this.state;
            const { preferences } = data;
            data.avatar = avatarUrl(data._id)
            //const avatar = avatarUrl(data._id)+`?d=${this.state.sequence++}`

            if (!data.primeMembership) {
                data.primeMembership = {
                    active: false,
                    renewalDate: null,
                    autoRenew: false
                }
            }
                      
            if (!data.preferences) {                  
                data.preferences = {
                    darktheme: false,
                    notificationsNewPost: true,
                    notificationsNewProduct: true, 
                    notificationsNewResource: true, 
                    notificationsNewNewsletter: true, 
                    notificationsNewAnnouncement: true, 
                    notificationsNewComment: true
                }
            }

            const notifications = [
                { l: 'New Blog Posts', v: 'notificationsNewPost', c: preferences ? preferences.notificationsNewPost : null }, 
                { l: 'New Product Releases', v: 'notificationsNewProduct', c: preferences ? preferences.notificationsNewProduct : null }, 
                { l: 'New Resource Added', v: 'notificationsNewResource', c: preferences ? preferences.notificationsNewResource : null }, 
                { l: 'Newsletter Published', v: 'notificationsNewNewsletter', c: preferences ? preferences.notificationsNewNewsletter : null }, 
                { l: 'Announcements', v: 'notificationsNewAnnouncement', c: preferences ? preferences.notificationsNewAnnouncement : null }, 
                { l: 'New Comment on Post', v: 'notificationsNewComment', c: preferences ? preferences.notificationsNewComment : null }
            ]
            return (                                
                <div className="dashboard-right">
                    <div className="dashboard">
                        <div className="page-title">
                            <h2>My Dashboard</h2>
                        </div>
                        <div className="welcome-msg">
                            <p>Hello, {data.fullname} !</p><br/>
                            <p>From your Account Dashboard you have the ability to view and edit your
                                account information. You also have access to your available downloads 
                                or event landing pages.  </p>
                        </div>
                        <div className="box-account box-info">
                            <div className="box-head">
                                <h2>Account Information</h2>
                            </div>
                            <br />
                            
                            <div className="row" >

                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <PersonalInfo 
                                        data={{
                                            displayname: data.displayname,
                                            firstname: data.firstname,
                                            lastname: data.lastname,
                                            phone: data.phone,
                                            email: data.email
                                        }} 
                                        title="Contact Information"
                                        onCloseModal={this.onClosePersonalInfoModal}
                                    />                                                                         
                                </div>
                                
                                <div className="col-sm-1" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                </div>
                                <div className="col-sm-5" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}> 
                                    <div className="box">
                                        <div className="box-title">
                                            <h3>Personal Avatar &nbsp;&nbsp;<button className="badge badge-info " onClick={this.onOpenAvatarModal}>Edit Avatar</button></h3>
                                        </div>
                                        <div className="box-content">
                                            <AvatarDisplay sequence={this.state.sequence} userId={data._id} prefix={<span style={{cursor: 'pointer', textDecoration: "underline"}}></span>}/>                                                                                                                               
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row" >
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <div className="box">
                                        <div className="box-title">
                                            <h3>Membership Information &nbsp;&nbsp;</h3>
                                        </div>
                                        <div className="box-content">  
                                            <h6>Membership Status: <span><b>Tournament Active</b></span></h6>                                        

                                            {/* _LI disabled temporarily
                                            <h6>Membership Status: <span><b>{data.primeMembership.active ? "Active" : "Inactive"}
                                                {!data.primeMembership.active && 
                                                <Link to={`${process.env.PUBLIC_URL}/checkoutMembership`} >
                                                        &nbsp;&nbsp;&nbsp;<strong>(Activate Now!)</strong>
                                                </Link>}
                                            </b></span></h6>
                                            */}
                                            <h6>Renewal Date: <span><b>{formatDate(new Date(data.primeMembership.renewalDate))}</b></span></h6>
                                            {data.primeMembership && data.primeMembership.autoRenew &&
                                            <div className="custom-control custom-checkbox collection-filter-checkbox">
                                                <input type="checkbox" onChange={this.onMembershipDataChange}  value="autoRenew" checked={data.primeMembership.autoRenew}  className="custom-control-input" id="autoRenew" />
                                                <label className="custom-control-label" htmlFor="autoRenew">Auto Renew</label>                                            
                                            </div>
                                            }
                                        </div>
                                    </div>                                 
                                </div>
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <div className="box">
                                        <div className="box-title">
                                            <h3>Notifications &nbsp;&nbsp;<button className="badge badge-info" onClick={this.sendTestNotification}>{`Send Test ${this.state.sendingText}`}</button></h3>
                                        </div>
                                        <div className="box-content">
                                            {notifications.map((notification, index) => {
                                                return (
                                                <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                    <input type="checkbox" onChange={this.onPreferenceDataChange}  value={notification.v} checked={notification.c}  className="custom-control-input" id={`${notification.v}`} />
                                                    <label className="custom-control-label" htmlFor={notification.v}>{notification.l}</label>
                                                </div> )
                                            })}
                                        </div>
                                    </div>                                
                                </div>
                            </div>   

                            <div className="row">
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <AddressForm 
                                        data={{
                                            street: data.billStreet,
                                            city: data.billCity,
                                            state: data.billState,
                                            postalCode: data.billPostalCode,
                                            country: data.billCountry
                                        }} 
                                        title="Billing Address"
                                        onCloseModal={this.onCloseBillModal}
                                    />                                            
                                </div>
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <AddressForm 
                                        data={{
                                            street: data.shipStreet,
                                            city: data.shipCity,
                                            state: data.shipState,
                                            postalCode: data.shipPostalCode,
                                            country: data.shipCountry
                                        }} 
                                        title="Shipping Address"
                                        onCloseModal={this.onCloseShipModal}
                                    /> 
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <TournamentProfile
                                        data={{
                                            club: data.club,
                                            experience: data.experience,
                                            gender: data.gender,
                                            age: data.ageGroup,
                                            phone: data.phone,
                                        }} 
                                        title="Tournament Profile"
                                        onCloseModal={this.onCloseTournamentProfileModal}
                                    /> 
                                               
                                </div>
                                <div className="col-sm-6" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <Bio 
                                        data={{
                                            bio: data.bio
                                        }} 
                                        title="Short Biography"
                                        onCloseModal={this.onCloseBio}
                                    /> 
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-sm-12" style={{borderBottom: "1px dashed #dddddd", paddingBottom: "8px",  marginBottom: "32px"}}>
                                    <div className="box">
                                        <div className="box-title">
                                            <h3>Permissions &nbsp;&nbsp;</h3>
                                        </div>
                                        <div className="box-content">
                                            <TagList title="" tags={data.permissions} hideBorder/>
                                        </div>
                                    </div>                                            
                                </div>
                            </div>

                    </div>
                </div>
                <Modal open={this.state.openAvatar} onClose={this.onCloseAvatarModal} >
                    <div className="modal-header">
                        <h5 className="modal-title f-w-600" id="exampleModalLabel2">
                        Edit Profile Image
                        </h5>
                    </div>
                    <div className="modal-body">
                        <AvatarEditor userAvatar={avatarUrl(data._id)+`?seq=${this.state.sequence}`} onCrop={this.onAvatarCrop}/>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => this.onCloseAvatarModal(true)}>Save</button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.onCloseAvatarModal(false)}>Discard</button>
                    </div>
                </Modal>

                {this.state.openId === "1" && 
                    <ModalWindow title="Membership Renewal" open={this.state.open} onCancel={this.onCancel}
                        content="If you disable auto-renewal, you cannot re-enable it.  Your membership will continue until the renewal date."
                        commands={[
                            {title: "Turn off Auto-Renew", handler: this.turnOffAutoRenew}
                        ]}
                    />
                }
            </div>
        )
    }
}

export default DBAccountInfo